<template>
  <div class="user-center-container" :class="{
    '--unauthed-merchant': user && user.isMerchant && !user.isAuthMerchant,
  }">
    <div class="user-center__header-container">
      <img src="~@/assets/images/ucb-1.jpg" alt="" />
      <div class="header-container__data-statistics-container" v-if="user && user.isMerchant && user.isAuthMerchant">
        <div class="dsc__item">
          <p>{{ storepv && storepv.today }}</p>
          <p>今日浏览</p>
        </div>
        <div class="dsc__item">
          <p>{{ storepv && storepv.total }}</p>
          <p>总浏览量</p>
        </div>
      </div>
    </div>
    <div class="user-center__main-container" :class="{
      '--sidebar-hidden': !(meta && meta.isShowSideBar),
    }">
      <div class="user-center-sidebar-container">
        <SideBar :links="currentNav" :nickname="user.nickname" :avatar="user.avatar" :identity-name="user.identity_name">
        </SideBar>
      </div>
      <div v-if="user && user.isMerchant && !user.isAuthMerchant" class="header-container__top-nav">
        <div class="top-nav__item">
          <router-link to="/my/auth" class="item__link">商家认证</router-link>
        </div>
        <div class="top-nav__item">
          <router-link to="/my/notices" class="item__link">我的消息</router-link>
        </div>
        <div class="top-nav__item">
          <router-link to="/my/profile/edit" class="item__link">修改店铺</router-link>
        </div>
      </div>
      <div class="main-container__wrapper">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import SideBar from "../_sidebar.vue";
import { unreadFollowupCount, followupConfig } from "@/api/user";

export default {
  components: {
    SideBar,
  },
  data() {
    return {
      meta: null,
      sidebarLinks: [
        // type 0 个人用户;type 1 厂商;type 2 经销商; type 3 个人商户 ；type  4 设计单位
        // {
        //   name: '我的动态',
        //   icon: 'icon-dynamic',
        //   url: '/my/dynamics',
        //   exact: true,
        //   scope: [0, 1, 2, 4], // 控制显示,
        //   disable: [2], // 是否置灰
        // },
        {
          name: "管理中心",
          icon: "icon-my-shop-manage",
          url: "/my/manage/",
          exact: false,
          scope: [0, 1, 2, 4],
          disable: [], //如果是经销商  暂时放开 2
        },
        {
          name: "企业主页",
          icon: "icon-my-shop",
          url: "#",
          exact: false,
          scope: [1, 2, 4],
          disable: [],
        },
        {
          name: "推荐商家",
          icon: "icon-recomend",
          url: "/my/recommendStore",
          exact: true,
          scope: [4], // 控制显示,
          disable: [], // 是否置灰
        },
        {
          name: "设计案例共享计划",
          icon: "icon-recommendCase",
          url: "/my/recommendCase",
          exact: true,
          scope: [4], // 控制显示,
          disable: [], // 是否置灰
        },
        {
          name: "我的供应商",
          icon: "icon-supplier",
          url: "/my/supplier",
          exact: true,
          scope: [4], // 控制显示,
          disable: [], // 是否置灰
        },
        {
          name: "项目清单",
          icon: "icon-my-collect",
          disabledIcon: "icon-my-pro-list",
          url: "/my/collects",
          exact: true,
          scope: [0, 4],
          disable: [],
        },
        {
          name: "我的案例",
          icon: "icon-case",
          url: "/my/cases/list",
          exact: false,
          scope: [0],
          disable: [],
        },
        {
          name: "我的消息",
          icon: "icon-my-notice",
          url: "/my/notices",
          exact: false,
          scope: [0, 1, 2, 4],
          disable: [],
        },
        {
          name: "我的需求",
          icon: "icon-my-requirement",
          url: "/my/requirements",
          exact: false,
          scope: [0, 4],
          disable: [],
        },
        {
          name: "项目跟进",
          icon: "icon-my-requirement",
          url: "/my/maintains",
          exact: false,
          scope: [1, 2],
          disable: [],
        },
        {
          name: "我的订单",
          icon: "icon-my-order",
          url: "/my/orders",
          exact: false,
          scope: [0, 1, 2, 4],
          disable: [2],
        },
        {
          name: "修改信息",
          icon: "icon-my-info",
          url: "/my/profile/edit",
          exact: false,
          scope: [0],
          disable: [],
        },
        {
          name: "我的购物车",
          icon: "icon-my-cart",
          url: "/my/cart",
          exact: false,
          scope: [0, 4],
          disable: [0],
        },
        {
          name: "我的认领",
          icon: "icon-chain",
          url: "/my/claim",
          exact: false,
          scope: [1, 2],
          disable: [2],
        },
        {
          name: "认领项目",
          icon: "icon-chain",
          url: "/search/case",
          exact: false,
          scope: [1, 4],
          disable: [],
        },
        {
          name: "项目信息",
          icon: "icon-browse-lx",
          url: "/my/contact",
          exact: false,
          scope: [0, 1, 2],
          disable: [],
        },
        {
          name: "浏览记录",
          icon: "icon-browse",
          url: "/my/access/record",
          exact: false,
          scope: [1, 2],
          disable: [2],
        },
        {
          // name: '积分消耗报告',
          name: "我的推广",
          icon: "icon-my-integral",
          url: "/my/promote",
          exact: false,
          scope: [1, 2],
          disable: [],
        },
        {
          name: "升级厂家店",
          icon: "icon-upgrade",
          url: "/my/auth",
          exact: false,
          scope: [2],
          disable: [],
        },
        {
          name: "我的商城",
          icon: "icon-my-mall",
          url: "",
          exact: false,
          scope: [1],
          disable: [],
        },
        {
          name: "商城管理后台",
          icon: "icon-my-manage",
          url: "",
          exact: false,
          scope: [1],
          disable: [],
        },
        // {
        //   name: "灵感搜索",
        //   icon: "icon-lgsearch",
        //   url: "/search/lq",
        //   exact: false,
        //   scope: [1, 4],
        //   disable: [],
        // },
      ],
    };
  },
  computed: mapState("user", {
    user: (state) => state.info,
    storepv: (state) => state.pv,
    currentNav() {
      // if(this.user.identity == 8) this.user.type = 4
      console.log(this.user, "<<<<==user.type");
      let temp = [];
      const type = this.user && this.user.type === undefined ? 0 : this.user.type;
      temp = this.sidebarLinks
        .filter((item) => {
          const itemTemp = item;
          if (itemTemp.name === "企业主页") {
            if (this.user.identity == 8) {
              itemTemp.url = `/member/${this.user.id}/cases`;
            } else {
              itemTemp.url = `/merchant/${this.user.store_id}/cases`;
            }
          }
          return itemTemp.scope.includes(type);
        })
        .map((item) => {
          const s = item;
          s.disable =
            item.disable.length > 0 &&
            item.disable.some((disableItem) => this.user.isDated || disableItem === type);
          return s;
        });
      return temp;
    },
  }),
  watch: {
    $route: {
      handler: "init",
      immediate: true,
    },
  },
  async created() {
    this.$on("followupread", () => {
      this.serializeSideRead("项目跟进", 0);
    });

    await this.unreadFolloup();
    await this.getFollowupConfig();
  },
  mounted() {
  },
  methods: {
    ...mapActions("user", ["pv"]),
    ...mapMutations(["SET_FOLLOWUP_CONFIGS"]),
    init(val) {
      this.meta = val.meta;
      if (this.user.isMerchant && !this.storepv) {
        this.pv();
      }
    },
    async unreadFolloup() {
      const count = await unreadFollowupCount();
      this.serializeSideRead("项目跟进", count.data);
    },
    async getFollowupConfig() {
      const res = await followupConfig();
      this.SET_FOLLOWUP_CONFIGS(res.data);
    },
    serializeSideRead(name, count) {
      this.sidebarLinks = this.sidebarLinks.map((item) => {
        const temp = item;
        if (temp.name === name) {
          temp.unread = count;
        }
        return temp;
      });
    },
  },
};
</script>

<style>
.header-wrapper-container {
  border-bottom: 1px solid rgba(239, 239, 239, 0.3);
}
</style>
